import axios from "axios";

export default {
	listTeams(ctx) {
		return axios.get("/v3/admin/teams", { params: ctx });
	},

	listTeamsWithUsers(ctx) {
		ctx.users = "y";
		return axios.get("/v3/admin/teams", { params: ctx });
	},

	getTeam(id) {
		return axios.get(`/v3/admin/team/${id}`);
	},

	saveTeam(team) {
		return axios.post("/v3/admin/team", team);
	},

	removeTeam(id) {
		return axios.delete(`/v3/admin/team/${id}`);
	},

	assignUserToTeam(userID, teamID) {
		return axios.post(`/v3/admin/user/${userID}/assign_team/${teamID}`);
	},

	removeUserTeam(userID) {
		return axios.post(`/v3/admin/user/${userID}/remove_team`);
	},

	promoteUser(teamID, userID) {
		return axios.post(`/v3/admin/team/${teamID}/promote/${userID}`);
	},

	demoteUser(teamID, userID) {
		return axios.post(`/v3/admin/team/${teamID}/demote/${userID}`);
	},

	getTeamUsers(teamID, ctx) {
		return axios.get(`/v3/admin/team/${teamID}/users`, { params: ctx });
	}
};



// WEBPACK FOOTER //
// ./src/services/TeamService.js